import React from 'react';
import { Divider } from '@mui/material';
import { AdminPanelSettings as Admin } from '@mui/icons-material';
import { AUTH_LEVELS } from '../../../auth/Authorized';
import NavDrawerMenu from './NavDrawerMenu';
import DrawerItem from './DrawerItem';

const AdminMenu = ({ isOpen }) => (
  <NavDrawerMenu text="Admin" drawerOpen={isOpen} icon={Admin} authLevel={AUTH_LEVELS.SUPER_ADMIN}>
    <DrawerItem to="/users" text="User management" />
    <DrawerItem to="/building-edit" text="Building management" />
    <Divider />
    <DrawerItem to="/actions-audit" text="Action Log Audit" />
    <Divider />
    <DrawerItem to="/upload" text="Upload" />
  </NavDrawerMenu>
);

export default AdminMenu;
